import React, {useState, useRef, useEffect, useContext} from 'react';
import { useHistory } from 'react-router-dom';
import {Container, Row, Col, Tooltip, Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import classes from './Mentor.module.css';
import {getCampus,getLevels,getOrigins,register, validateEmptyFields} from "../../../helpers/Register.helper";
import GlobalContext from '../../../context/GlobalContext';
import { Paises } from '../../../helpers/Data.helper';
import { isEmpty } from 'rxjs-compat/operator/isEmpty';
import { sortData } from '../../../helpers/functions.helper';

const Mentor = () => {

    const [isHidden, setIsHidden] = useState(true);
    const [modalToggle, setModalToggle] = useState(false);
    const [isConfirmHidden, setIsConfirmHidden] = useState(true);
    const [isPassValid, setIsPassValid] = useState(false);
    const [passShow, setPassShow] = useState(false);
    const [passMessage, setPassMessage] = useState('');
    const [ConfirmPassShow, setConfirmPassShow] = useState(false);
    const [campus, setCampus] = useState([]);
    const [levels, setLevels] = useState([]);
    const [origins, setOrigins] = useState([]);
    const [modalHeader, setModalHeader] = useState('');
    const [modalBody, setModalBody] = useState('');
    const [modalRedirect, setModalRedirect] = useState(false);

    const history = useHistory();

    const {setLoading} = useContext(GlobalContext);

    const nombre = useRef();
    const sexo = useRef();
    const email = useRef();
    const confirmEmail = useRef();
    const pass = useRef();
    const confirmPass = useRef();
    const icon = useRef();
    const confirmIcon = useRef();
    const ciudad = useRef();
    const pais = useRef();
    const nomina = useRef();
    const matricula = useRef();
    const nombreEmpresa = useRef();
    const añosEmpresa = useRef();
    const puesto = useRef();
    const actividades = useRef();
    const motivos = useRef();
    const camp = useRef();
    const nivel = useRef();
    const origen = useRef();

    useEffect( () => {
        getCampus().then((d) => setCampus(d));
        getOrigins().then((d) => setOrigins(d));
        getLevels().then((d) => setLevels(d));

        const antiguedad = document.getElementById('años-empresa');
        const nomina_elem = document.getElementById('nomina');
        const matricula_elem = document.getElementById('matricula');
        
        antiguedad.addEventListener('keydown', handleKeyDown);
        nomina_elem.addEventListener('keydown', handleKeyDown);
        matricula_elem.addEventListener('keydown', handleKeyDown);

        return () => {
            antiguedad.removeEventListener('keydown', handleKeyDown);
            nomina_elem.removeEventListener('keydown', handleKeyDown);
            matricula_elem.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    useEffect(()=>{
        if(campus.length > 0){
           setCampus(sortData(campus));
        }
    }, [campus])

    const showHidePassword = (pass, icon, isHidden, setIsHidden) => {
        if(!isHidden){
            pass.current.setAttribute('type', 'password');
            icon.current.classList.remove('fa-eye-slash');
            icon.current.classList.add('fa-eye');
            setIsHidden(true);
        }else{
            pass.current.setAttribute('type', 'text');
            icon.current.classList.remove('fa-eye');
            icon.current.classList.add('fa-eye-slash');
            setIsHidden(false);
        }
    }

    const handleOnFocus = elem => {
        const text = elem.current.closest('.input-container').children[0];
        text.classList.add('active');
        setPassShow(false);
        setConfirmPassShow(false);

        if(elem.current.id == 'pass' || elem.current.id == 'confirm-pass'){
            elem.current.select();
            elem.current.removeAttribute('style');
        }
    }

    const handleOnBlur = elem => {
        const value = elem.current.value;
        if(!value.length > 0){
            const text = elem.current.closest('.input-container').children[0];
            text.classList.remove('active');
        };

        if(elem.current.id == 'pass' || elem.current.id == 'confirm-pass'){
            validatePassword(elem);
        }
    }

    const validatePassword = elem => {
        const value = elem.current.value;

        if(value.length == 0){
            elem.current.classList.remove('active');
            setPassShow(false);
            setConfirmPassShow(false);
            return;
        }

        if(elem.current.id == 'pass'){
            if(!checkPass(value)){
                elem.current.style.border = '1px solid red';
                setPassShow(true);
                setIsPassValid(false);
            }else{
                elem.current.style.border = '1px solid green';
            }
        }else{
            const passValue = pass.current.value;
            if(value != passValue || !checkPass(value)){
                if(value.length > 12){
                    setPassMessage('La contraseña debe contener menos de 12 caracteres.');
                }else if(passValue.length < 6){
                    setPassMessage('Recuerda que la contraseña debe contener mínimo 6 caracteres.');
                }else{
                    setPassMessage('Las contraseñas deben coincidir.');
                }
                elem.current.style.border = '1px solid red';
                setConfirmPassShow(true);
                setIsPassValid(false);
            }else{
                elem.current.style.border = '1px solid green';
                setIsPassValid(true);
            }
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if(email.current.value != confirmEmail.current.value){
            showModal(
                "Los correos no coinciden",
                "Por favor ingresa de nuevo tu cofirmación de correo.",
                false
            );
            return;
        }

        if(!isPassValid){
            showModal(
                "La contraseña no cumple con lo requisitos",
                "Por favor ingresa una contraseña que cumpla con todos los requisitos.",
                false
            );
            return;
        }

        //validar nombre del mentor
        const SplitName = nombre.current.value.split(" ");
        if(SplitName.length < 2 || !SplitName[1]){
            showModal(
                "El nombre no es correcto.",
                "Por favor ingresa correctamente tu nombre.",
                false
            );
            return
        }

        const mentor = {
            sNombre: nombre.current.value,
            sCorreo: email.current.value,
            sCiudadResidencia: ciudad.current.value,
            sPaisResidencia: pais.current.value,
            iNomina: nomina.current.value.replace( /^\D+/g, ''),
            iMatricula: matricula.current.value.replace( /^\D+/g, ''),
            sPassword: pass.current.value,
            sEmpresa: nombreEmpresa.current.value,
            iAntiguedad: añosEmpresa.current.value,
            sPuesto: puesto.current.value,
            sPrincipalesActividades: actividades.current.value,
            sMotivos: motivos.current.value,
            idCampus: camp.current.value,
            idNivel: nivel.current.value,
            sSexo: sexo.current.value,
            idOrigen: origen.current.value,
        }

        const validation = validateEmptyFields(mentor);
        if(validation != false){
            showModal(
                "Uno o más campos están vacíos.",
                validation,
                false
            );
            return;
        }

        setLoading(true);

        console.log(mentor);
        register(mentor).then(resp => {
            setLoading(false);
            showModal(
                "Gracias por iniciar tu registro en Soy Mentor",
                `Gracias por registrarte en Soy Mentor. En 24 horas hábiles, recibirás un correo con las indicaciones para acreditar tu registro.
                <br/>Si no te hemos contestado no es necesario que te registres nuevamente solo por favor manda correo a: <a href='mailto:soymentor@tecmilenio.mx'>soymentor@tecmilenio.mx</a>  y con gusto revisaremos tu caso.`,
                true
            );
        }).catch(error=>{
            setLoading(false);
            const message = (error.error) ? error.error : error.message;
            if(message){
                showModal(
                    "Ha ocurrido un error.",
                    message,
                    false
                );
            }else{
                showModal(
                    "Ha ocurrido un error.",
                    "Ha ocurrido un error inesperado, intente de nuevo",
                    false
                );
            }
        });
    }

    const checkPass = pass => {
        const str = pass;
        const formatSpetial = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        const formatUppercase = /[ABCDEFGHIJKLMNÑOPQRSTUVWXYZ]/;
        const formatLowercase = /[abcdefghijklmnñopqrstuvwxyz]/;
        const formatNumber = /[1234567890]/;
        if (formatSpetial.test(str) && formatUppercase.test(str) && formatLowercase.test(str) && formatNumber.test(str) && str.length >= 6 && str.length <= 12)
            return true;
        else
            return false;
    }

    const showModal = (header, body, redirect) => {
        setModalHeader(header);
        setModalBody(body);
        setModalRedirect(redirect);
        setModalToggle(true);
    }

    const handleClick = (redirect) => {
        setModalToggle(!modalToggle);
        if(redirect){
            window.scrollTo(0,0);
            history.push('/');
        }
    }

    const handleKeyDown = e =>{
        const nonValidatedKeys = [8, 9, 13, 16, 17, 37, 38, 39, 40];
        if(nonValidatedKeys.includes(e.which)){return}

        let value = e.currentTarget.value;
        if(e.currentTarget.id == 'años-empresa'){
            if(value.length >= 2){
                e.preventDefault()
            }
        }else{
            if(value.length >= 7){
                e.preventDefault();
            }
        }
    }

    return(
        <Container>
            <Row>
                <Col className="title-container">
                    <div>
                        <h1>Registro de Mentor Voluntario</h1>
                        <span>Completa tu información y conviértete en un mentor voluntario</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col style={{marginBottom: '20px'}}>
                    <form onSubmit={handleSubmit} autoComplete="off">
                        
                        <div className={"input-container " + classes.inputContainer} style={{maxWidth: "70%"}}>
                            <label className={classes.text} htmlFor="nombre">Nombre completo*</label>
                            <input type="text" id="nombre" className={classes.input} onFocus={()=>{handleOnFocus(nombre)}} onBlur={()=>{handleOnBlur(nombre)}} ref={nombre}/>
                            <span className={classes.subtitleInfo}>Agradecemos que coloques tu nombre y apellidos correctamente</span>
                        </div>

                        <div className={classes.flexContainer}>
                            <div className={"input-container " + classes.inputContainer}>
                                <label className={classes.text} htmlFor="email">Correo electrónico*</label>
                                <input type="email" id="email" className={classes.input} onFocus={()=>{handleOnFocus(email)}} onBlur={()=>{handleOnBlur(email)}} ref={email}/>
                                <span className={classes.subtitleInfo}>No olvides colocar <b style={{color: 'red'}}>correctamente</b> tu correo</span>
                            </div>
                            <div className={"input-container " + classes.inputContainer}>
                                <label className={classes.text} htmlFor="confirm-email">Confirmar correo electrónico*</label>
                                <input type="email" id="confirm-email" className={classes.input} onFocus={()=>{handleOnFocus(confirmEmail)}} onBlur={()=>{handleOnBlur(confirmEmail)}} ref={confirmEmail}/>
                            </div>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text + " active"} htmlFor="genero">Género*</label>
                            <select id="genero" className={classes.input} ref={sexo}>
                                <option value="Masculino">Masculino</option>
                                <option value="Femenino">Femenino</option>
                                <option value="0">Prefiero no decirlo</option>
                            </select>
                        </div>

                        <div className={classes.flexContainer}>
                            <div className={"input-container " + classes.inputContainer}>
                                <label className={classes.text} htmlFor="pass">Contraseña*</label>
                                <span>
                                    <input type="password" id="pass" is-hidden="true" className={classes.input}
                                    onFocus={()=>{handleOnFocus(pass)}} onBlur={()=>{handleOnBlur(pass)}} ref={pass}/>
                                    <span className={classes.icon} onClick={()=>{showHidePassword(pass, icon, isHidden, setIsHidden)}}><i className="fas fa-eye" ref={icon}></i></span>
                                </span>
                                <Tooltip placement="top" fade={false} isOpen={passShow} target="pass">
                                    La contraseña debe contener entre 6 y 12 caracteres, una minúscula, una mayúscula, un número y un caracter especial.
                                </Tooltip>
                            </div>
                            <div className={"input-container " + classes.inputContainer}>
                                <label className={classes.text} htmlFor="confirm-pass">Confirmar contraseña*</label>
                                <span>
                                    <input type="password" id="confirm-pass" is-hidden="true" className={classes.input}
                                    onFocus={()=>{handleOnFocus(confirmPass)}} onBlur={()=>{handleOnBlur(confirmPass)}} ref={confirmPass}/>
                                    <span className={classes.icon} onClick={()=>{showHidePassword(confirmPass,confirmIcon, isConfirmHidden, setIsConfirmHidden)}}><i className="fas fa-eye" ref={confirmIcon}></i></span>
                                </span>
                                <Tooltip placement="top" fade={false} isOpen={ConfirmPassShow} target="confirm-pass">
                                    {passMessage}
                                </Tooltip>
                            </div>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text} htmlFor="ciudad">Ciudad de residencia*</label>
                            <input type="text" id="ciudad" className={classes.input} onFocus={()=>{handleOnFocus(ciudad)}} onBlur={()=>{handleOnBlur(ciudad)}} ref={ciudad}/>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text + ' active'} htmlFor="pais">País de residencia*</label>
                            <select id="pais" className={classes.input} ref={pais}>
                                {
                                    Paises.map((item, index)=>(
                                        (item.nombre)&&
                                        <option value={item.nombre} key={item.id}>{item.nombre}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text + ' active'} htmlFor="campus">Campus presencial más cercano*</label>
                            <select id="campus" className={classes.input} ref={camp}>
                                {
                                    campus.map((item, index)=>(
                                        <option value={item.idCampus} key={item.idCampus}>{item.sCampus}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <span className={classes.subtitle}>Perteneces a la comunidad Tecmilenio o Tec</span>
                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text + ' active'} htmlFor="nivel">Segmento el que perteneces*</label>
                            <select id="nivel" className={classes.input} ref={origen}>
                                {
                                    origins.map((item, index)=>(
                                        <option value={item.idOrigen} key={item.idOrigen}>{item.sOrigen}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text} htmlFor="nomina">Nómina* (Solo para colaborador/docente)</label>
                            <input type="number" id="nomina" className={classes.input} onFocus={()=>{handleOnFocus(nomina)}} onBlur={()=>{handleOnBlur(nomina)}} ref={nomina}/>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text} htmlFor="matricula">Matrícula* (Solo para estudiantes)</label>
                            <input type="number" id="matricula" className={classes.input} onFocus={()=>{handleOnFocus(matricula)}} onBlur={()=>{handleOnBlur(matricula)}} ref={matricula}/>
                        </div>

                        <span className={classes.subtitle}>Cuéntanos sobre tu actividad laboral principal</span>
                        <span className={classes.subtitleInfo}>Si eres estudiante no es necesario que completes esta sección</span>
                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text} htmlFor="nombre-empresa">Nombre de la empresa*</label>
                            <input type="text" id="nombre-empresa" className={classes.input} onFocus={()=>{handleOnFocus(nombreEmpresa)}} onBlur={()=>{handleOnBlur(nombreEmpresa)}} ref={nombreEmpresa}/>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text} htmlFor="años-empresa">Años en la empresa* (número)</label>
                            <input type="number" id="años-empresa" className={classes.input} onFocus={()=>{handleOnFocus(añosEmpresa)}} onBlur={()=>{handleOnBlur(añosEmpresa)}} ref={añosEmpresa}/>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text} htmlFor="puesto">Puesto*</label>
                            <input type="text" id="puesto" className={classes.input} onFocus={()=>{handleOnFocus(puesto)}} onBlur={()=>{handleOnBlur(puesto)}} ref={puesto}/>
                        </div>

                        <div className={"input-container " + classes.inputContainer}>
                            <label className={classes.text} htmlFor="actividades">Principales actividades que realizas*</label>
                            <input type="text" id="actividades" className={classes.input} onFocus={()=>{handleOnFocus(actividades)}} onBlur={()=>{handleOnBlur(actividades)}} ref={actividades}/>
                        </div>

                        <span className={classes.subtitle}>Selecciona el segmento de estudiantes al que preferirías dar mentoría*</span>
                        <div className={"input-container " + classes.inputContainer}>
                            <select className={classes.input} ref={nivel}>
                                {
                                    levels.map((item, index)=>(
                                        <option value={item.idNivel} key={item.idNivel}>{item.sNivel}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className={"input-container " + classes.inputContainer} style={{maxWidth: "70%"}}>
                            <label className={classes.text} htmlFor="motivos">Motivos para ser mentor voluntario*</label>
                            <textarea id="motivos" className={classes.input} onFocus={()=>{handleOnFocus(motivos)}} onBlur={()=>{handleOnBlur(motivos)}} ref={motivos}/>
                        </div>

                        <span className={classes.notice}>Al registrarte, confirmas estar de acuerdo con el aviso de Privacidad para mentores voluntarios <a href="/Home/AvisoPrivacidadMentores">Consultar</a></span>

                        <input type="submit" className={classes.submit} value="Registrarme como mentor" />
                    </form>

                    {/* MODAL */}
                    <div>
                        <Modal size="lg" isOpen={modalToggle} >
                            <ModalHeader toggle={()=>{setModalToggle(!modalToggle)}}>{modalHeader}</ModalHeader>
                            <ModalBody dangerouslySetInnerHTML={{__html: modalBody}}></ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={()=>{handleClick(modalRedirect)}} >
                                    Aceptar
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                    
                </Col>
            </Row> 
        </Container>
    );

}
export default Mentor;
